module.exports = __webpack_public_path__ + "static/media/sample-email.f75c6807.gif";